document.addEventListener('DOMContentLoaded', () => {
  const attachPaginationListeners = () => {
    const paginationLinks = document.querySelectorAll('.Pagination__NavItem[data-url]');

    paginationLinks.forEach(link => {
      link.addEventListener('click', function (event) {
        event.preventDefault(); // Prevent default link behavior

        const url = this.getAttribute('data-url');

        // Fetch the new content via AJAX
        fetch(url)
          .then(response => {
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.text();
          })
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            // Replace the product grid content
            const newProducts = doc.querySelector('.ProductGrid'); // Adjust selector
            const currentProducts = document.querySelector('.ProductGrid');
            if (newProducts && currentProducts) {
              currentProducts.innerHTML = newProducts.innerHTML;
            } else {
              console.error('Error: Product grid container not found.');
            }

            // Replace pagination content
            const newPagination = doc.querySelector('.Pagination');
            const currentPagination = document.querySelector('.Pagination');
            if (newPagination && currentPagination) {
              currentPagination.innerHTML = newPagination.innerHTML;
            } else {
              console.error('Error: Pagination container not found.');
            }

            // Reattach pagination listeners
            attachPaginationListeners();
          })
          .catch(error => console.error('Error loading pagination:', error));
      });
    });
  };

  // Attach listeners initially
  attachPaginationListeners();
});
